import { provideRouter, withInMemoryScrolling } from '@angular/router'

import { bootstrapApplication } from '@framework/bootstrap'

import { AppComponent } from './app.component'
import { APP_ROUTES } from './app.routes'

// eslint-disable-next-line unicorn/prefer-top-level-await
bootstrapApplication(AppComponent, {
  providers: [provideRouter(APP_ROUTES, withInMemoryScrolling({ scrollPositionRestoration: 'top' }))],
})
